export const Config = {
  maxItems: 5,
  // Load well beyond maxItems so occasions the client-side visibility
  // filter discards cannot starve the list, and "Show more" knows about
  // every upcoming occasion (#1708).
  maxLoad: 100,
  portalType: 'InfoEvent',
  sortOn: 'occasion_start',
};
